const events = {
  'events-breadcrumbs': 'События',
  'event-details-title': 'Событие',
  'events-filter-title': 'Фильтр событий',
  'event-create-sidebar': 'Создание события',
  'events-launch-scenario-field': 'Сценарии запуска',
  'events-launch-scenario-field-placeholder': 'Укажите сценарий запуска',
  'events-form-field-launch-scenario-help': 'Здесь можно передать различные сценарии запуска в формате JSON',
  'events-unpublish-released-admin-warning': 'Это событие уже вышло где-то в мире. Вы уверены, что хотите отменить публикацию?',
  'events-unpublish-released-admin-only': 'Только администраторы могут снять с публикации событие, которое уже вышло где-то в мире',
  'events-edit-images-update-warning': 'Данное событие уже начато, обновление изображений приведет к потере прогресса пользователей',
  'events-edit-republish-warning': 'Повторная публикация обновлений для уже опубликованных событий несет за собой дополнительные денежные расходы',
  'event-types-event': 'Событие',
  'event-types-general': 'Общий',
};

export default events;
